import { FunnelStages as Stages } from './types';
import { formatNumber } from './utils';

export function FunnelStages({ stages }: { stages: Stages }) {
  const conv1 = stages.checkoutViews > 0 ? (stages.orders / stages.checkoutViews) * 100 : 0;
  const conv2 = stages.orders > 0 ? (stages.dispatched / stages.orders) * 100 : 0;
  const conv3 = stages.dispatched > 0 ? (stages.delivered / stages.dispatched) * 100 : 0;

  const stageItem = (label: string, value: number) => (
    <div className="flex flex-col items-center flex-1 min-w-0">
      <p className="text-xs uppercase tracking-wide text-gray-400 mb-1 text-center">{label}</p>
      <p className="text-xl font-medium text-gray-900">{formatNumber(value)}</p>
    </div>
  );

  const conversion = (pct: number, severity: 'good' | 'neutral' | 'warn') => {
    const color = severity === 'good' ? 'text-emerald-600' : severity === 'warn' ? 'text-amber-600' : 'text-gray-500';
    return (
      <div className="flex flex-col items-center px-2 shrink-0">
        <div className="flex items-center gap-1">
          <div className="w-6 h-px bg-gray-300" />
          <span className={`text-xs ${color}`}>{pct.toFixed(0)}%</span>
          <div className="w-6 h-px bg-gray-300" />
        </div>
      </div>
    );
  };

  return (
    <div className="flex items-center">
      {stageItem('Vistas checkout', stages.checkoutViews)}
      {conversion(conv1, conv1 >= 5 ? 'good' : 'neutral')}
      {stageItem('Órdenes', stages.orders)}
      {conversion(conv2, conv2 >= 50 ? 'good' : 'warn')}
      {stageItem('Despachadas', stages.dispatched)}
      {conversion(conv3, conv3 >= 80 ? 'good' : 'warn')}
      {stageItem('Entregadas', stages.delivered)}
    </div>
  );
}
